module.exports = __webpack_public_path__ + "assets/b312f3a7bdb8549c706134654614f7ae.png";